import React, { useCallback, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { sendMessageRoute } from '../utils/API_Routes'
import ChatInput from './ChatInput'
import Logout from './Logout'
import Messages from './Messages'
import useAxiosPrivate from '../hooks/usePrivateRoute'
import { useNavigate } from 'react-router-dom'
import { removeUser } from '../features/user/userSlice'
import { useDispatch, useSelector } from 'react-redux'
import { setMessages } from '../features/chat/chatSlice'
import { v4 as uuid } from 'uuid'
import useMessages from '../hooks/useMessages'
import { GiHamburgerMenu } from "react-icons/gi";
import Loading from './loading/Loading'
import ScrollToBottom from './ScrollToBottom'

const ChatContainer = ({ socket, setDisplayContacts }) => {
    const { messages } = useSelector(state => state.chat);
    const navigate = useNavigate();
    const [pageNum, setPageNum] = useState(1);
    const [recivedMessage, setReciveMessage] = useState(null);
    const [scrolledBottom, setIsScrolledBottom] = useState(true);
    const axiosPrivate = useAxiosPrivate();
    const { currentChat } = useSelector(state => state.chat);
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.user);
    const intObserver = useRef();
    const messagesRef = useRef();
    const scrollRef = useRef(null);
    const { isLoading, isError, hasNextPage, setIsNew } = useMessages(messages, pageNum, setPageNum);
    const clientHeight = messagesRef?.current?.clientHeight;
    const messageContentHeight = messagesRef?.current?.scrollHeight;

    useEffect(() => {
        setIsNew(prev => !prev);
        dispatch(setMessages([]))
        setPageNum(1);
    }, [currentChat])

    const handleScroll = useCallback((e) => {
        setIsScrolledBottom(Math.abs(e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop) <= 1)
    }, [])
    const handleScrollBottom = () => {
        scrollRef?.current?.scrollIntoView()
    }
    const lastMessageRef = useCallback(node => {
        if (isLoading) return;

        if (intObserver.current) {
            intObserver.current.disconnect();
        }
        intObserver.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasNextPage) {
                setPageNum(prev => prev + 1)
            }
        })
        if (node) intObserver.current.observe(node);
    }, [isLoading, hasNextPage])

    if (isError) {
        navigate('/login');
        dispatch(removeUser())
    }


    const content = messages.map((msg, i) => {
        if (i === 0) {
            return <Messages ref={lastMessageRef} key={msg.uid} message={msg} />
        }
        if (i === messages.length - 1) {
            return <Messages ref={scrollRef} key={msg.uid} message={msg} />
        }
        return <Messages key={msg.uid} message={msg} />
    })
    const handleSendMsg = async (msg) => {
        await axiosPrivate.post(sendMessageRoute, {
            from: user._id,
            to: currentChat._id,
            message: msg
        })
        socket.current.emit('send-msg', {
            to: currentChat._id,
            from: user._id,
            message: msg
        })
        const msgs = [...messages]
        msgs.push({ fromSelf: true, message: msg, time: new Date().getTime(), uid: uuid() })
        dispatch(setMessages(msgs));
    }

    useEffect(() => {
        if (socket.current) {
            socket.current.on('msg-recieve', (msg) => {
                setReciveMessage({ fromSelf: false, message: msg, time: new Date().getTime(), uid: uuid() })
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        recivedMessage && dispatch(setMessages([...messages, recivedMessage]))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [recivedMessage])
    return (
        <>
            {
                currentChat &&
                <Wrapper>
                    <div className="chat-header">
                        <div className="user-details">
                            <div className="contacts_ham" onClick={() => setDisplayContacts(true)}><GiHamburgerMenu /></div>
                            <div className="avatar">
                                <img src={`data:image/svg+xml;base64,${currentChat.avatarImage}`} alt="avatar" />
                            </div>
                            <div className="username">
                                <h3>{currentChat.Username}</h3>
                            </div>
                        </div>
                        <Logout socket={socket} />
                    </div>
                    <div className="chat-messages" ref={messagesRef} onScroll={handleScroll}>
                        <div className={`${isLoading ? 'display_loading' : 'hide_loading'}`}><Loading center={false} /></div>
                        {
                            content
                        }
                        {(messageContentHeight > clientHeight && !scrolledBottom) && <div onClick={handleScrollBottom} className='stb-btn'>
                            <ScrollToBottom />
                        </div>}
                    </div>
                    <ChatInput handleSendMsg={handleSendMsg} />
                </Wrapper>
            }
        </>
    )
}

const Wrapper = styled.div`
    display: grid;
    grid-template-rows: 10% 80% 10%;
    gap: 0.1rem;
    overflow: hidden;
    .chat-header{
        display:flex ;
        justify-content:space-between ;
        align-items:center ;
        padding:0 2rem ;
        .user-details{
            display:flex ;
            align-items:center ;
            .contacts_ham{
                display:none ;
                color:#9a86f3 ;
                font-size:1.3rem ;
            }
            gap:1rem;
            .avatar{
                img{
                    height:3rem;
                }
            }
            .username{
                h3{
                    color:#ffffff ;
                }
            }
        }
    }
    .chat-messages {
        padding: 1rem 2rem;
        display: flex;
        flex-direction: column;
        position:relative ;
        .stb-btn{
            position:fixed ;
            cursor: pointer;
            bottom:18% ;
            right:8%;
        }
        gap: 1rem;
        overflow: auto;
        .display_loading{
            display:block ;
        }
        .hide_loading{
            display:none ;
        }
        &::-webkit-scrollbar {
            width: 0.2rem;
            &-thumb {
                background-color: #ffffff39;
                width: 0.1rem;
                border-radius: 1rem;
            }
        }
    }
    @media screen and (min-width: 720px) and (max-width: 1080px) {
        grid-template-rows: 15% 70% 15%;
        .chat-messages {
            .stb-btn{
                bottom:22% ;
            }
        }
    }
    @media screen and (max-width: 720px) {
        .chat-header{
            .user-details{
                .contacts_ham{
                    display: inline;
                }
                .avatar{
                    img{
                        height:2rem;
                    }
                }
            }
        }
    }
`

export default ChatContainer